import { useContext, useEffect, useState } from 'preact/hooks';
import { sendPostMessage } from '../../helpers/post-message.helper';
import { ApplicationContext } from '../../services/use-application-setup';

// values according to the old data-grid positioning
enum Position {
  Left = 7,
  Center = 5,
  Right = 1,
}

export const usePosition = (onSaveCallback: () => void = () => {}) => {
  const { setUserSpecificPosition, userSpecificPosition, position, tunings } = useContext(
    ApplicationContext,
  );
  const [currentPosition, setCurrentPosition] = useState<Position>(null);

  const setPosition = (position: number) =>
    setCurrentPosition(position >= Position.Center ? Position.Left : Position.Right);


  useEffect(() => {
    const positioning = userSpecificPosition || position || +tunings?.widget_position;

    setPosition(positioning)
  }, [userSpecificPosition, position, tunings]);

  const setDefaultPosition = () => {
    const position = +tunings?.widget_position;

    if (!position) {
      return;
    }

    setPosition(position);
    setUserSpecificPosition(null);

    sendPostMessage({
      action: 'setWidgetPosition',
      position,
      byUser: true,
    });
  }

  const savePosition = (position: Position) => {
    setCurrentPosition(position);
    setUserSpecificPosition(position);

    onSaveCallback();

    sendPostMessage({
      action: 'setWidgetPosition',
      position,
      byUser: true,
      byMoveHideSection: true,
    });
  };

  return {
    currentPosition,
    savePosition,
    setDefaultPosition,
  };
};
